import { render, staticRenderFns } from "./LogbookTable.vue?vue&type=template&id=ef8ac448&scoped=true&"
import script from "./LogbookTable.vue?vue&type=script&lang=js&"
export * from "./LogbookTable.vue?vue&type=script&lang=js&"
import style0 from "./LogbookTable.vue?vue&type=style&index=0&id=ef8ac448&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ac448",
  null
  
)

export default component.exports